import type { InboxView, InboxViewColumn, InboxViewRow } from "@/types/inboxView/inboxView";
import { safeFilename, saveBlob } from "./exportFile";

export function exportViewToJson(
  view: InboxView,
  viewName: string,
  columns: InboxViewColumn[],
  rows: InboxViewRow[],
): void {
  const payload = {
    view: { id: view.id, name: viewName, description: view.prompt },
    exported_at: new Date().toISOString(),
    columns: columns.map(({ name, type, description }) => ({ name, type, description })),
    rows: rows.map((row) => ({
      id: row.id ?? null,
      source_conversation_id: row.source_conversation_id,
      occurred_at: row.occurred_at ?? null,
      added_at: row.created_at ?? null,
      handled_at: row.handled_at ?? null,
      data: row.data,
      scores: row.scores ?? null,
      match_reason: row.match_reason ?? null,
    })),
  };

  saveBlob(
    new Blob([JSON.stringify(payload, null, 2)], { type: "application/json;charset=utf-8;" }),
    `${safeFilename(viewName)}.json`,
  );
}
